// partner

$(".partner__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    asNavFor: ".partner__img-items",
});

$(".partner__img-items").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".partner__items",
    arrows: false,
    dots: false,
    focusOnSelect: true,
});


// featured-collection
if ($(window).width() < 767) {
    $(".featured-collection__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}


// testimonial
$(".testimonial__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
});


// recipe
if ($(window).width() < 767) {
    $(".recipe__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}



// gallery

if ($(Window).width() < 768) {
    $(".gallery__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
    

// // featured-collection
// if ($(window).width() < 767) {
//     $(".featured-collection__items").slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         dots: false,
//     });
//     }

$('.featured-collection__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.featured-collection__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});





// recipe__service start



if ($(Window).width() > 768) {
    $('.recipe__items_service').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}



$('.recipe__service-left-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});



$('.recipe__service-right-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});




// recipe__service end



// grow-service start


$('.grow__right-items').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        }
    }, ]
});


$('.grow__left-arrow').click(function () {
    $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
});



$('.grow__right-arrow').click(function () {
    $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
});



// grow-service end




$(document).on('click', '.download-link', function (e) {
    e.preventDefault();

    var url = $(this).attr('href');
    var fileName = url.split('/').pop().split('?')[0];


    fetch(url)
        .then(response => response.blob())
        .then(blob => {

            var blobUrl = window.URL.createObjectURL(blob);

            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Release the temporary URL
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(err => console.error('Download error:', err));
});





$(".cart-trigger").on('click',function(){
    $(".overly").addClass('active');
  })
  
  $(".cart-close").on('click',function(){
    $(".overly").removeClass('active');
    $("body").removeClass('cart-shown');
  })
  
  $(".overly").on('click', function(){
    $("body").removeClass('cart-shown');
    $(".overly").removeClass('active');
  })
  



  if ($(Window).width() < 768) {
    $('.upsell__items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
  ]
  });
  }
  
  
  $('.arrow-prev').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
  });
  
  $('.arrow-next').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
  });